/** Attribute the slot styles key their drop feedback off. */
export const DRAG_OVER_ATTRIBUTE = 'data-drag-over';

/** The drop target under the pointer. */
let owner: HTMLElement | null = null;
/** The slot element currently carrying the attribute. */
let highlighted: HTMLElement | null = null;

const paint = (slot: HTMLElement | null) => {
  if (highlighted === slot) return;
  highlighted?.removeAttribute(DRAG_OVER_ATTRIBUTE);
  highlighted = slot;
  slot?.setAttribute(DRAG_OVER_ATTRIBUTE, '');
};

/**
 * Shows the drop feedback on `slot` on behalf of the drop target `claimant`.
 *
 * Two different elements can ask for the same slot to light up: the slot itself
 * while the pointer is over it, and the card next to it while the pointer is
 * over the half of the card that lands there. Pragmatic publishes a drop-target
 * change as leave-then-enter, so the two never overlap in time — but routing
 * both through one owner still buys the invariant that a claim clears whatever
 * was lit, whoever lit it. That covers the case no lifecycle event does: a
 * target torn down mid-drag by a column refetch never fires `onDragLeave`, and
 * its highlight would otherwise stay up for the rest of the drag.
 *
 * Written as a DOM attribute rather than React state on purpose: a drag
 * crossing a column would otherwise re-render every slot and card it passes
 * over, mid-drag.
 */
export const claimHighlight = (
  claimant: HTMLElement,
  slot: HTMLElement | null
) => {
  owner = claimant;
  paint(slot);
};

/** Takes the highlight down, but only if `claimant` still owns it. */
export const releaseHighlight = (claimant: HTMLElement) => {
  if (owner !== claimant) return;
  owner = null;
  paint(null);
};
